export const TRANSFER_RESPONSIBILITIES_SAVE = "TRANSFER_RESPONSIBILITIES_SAVE";
export const TRANSFER_RESPONSIBILITIES_REMOVE = "TRANSFER_RESPONSIBILITIES_REMOVE";
export const TRANSFER_LOADING = "TRANSFER_LOADING";
